module.exports = __webpack_public_path__ + "img/Expireddocuments.b7aecb60.png";